import { createPlugin, createApiFactory, configApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef, vulnerabilityRouteRef } from './routes.esm.js';
import { vulnerabilitiesApiRef } from './api/vulnerabilitiesApi.esm.js';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { VulnerabilitiesClient } from './api/vulnerabititilesClient.esm.js';

const vulnerabilitiesPlugin = createPlugin({
  id: "vulnerabilities",
  apis: [
    createApiFactory({
      api: vulnerabilitiesApiRef,
      deps: { configApi: configApiRef, catalogApi: catalogApiRef },
      factory: ({ configApi, catalogApi }) => {
        return new VulnerabilitiesClient(configApi, catalogApi);
      }
    })
  ],
  routes: {
    root: rootRouteRef,
    vulnerability: vulnerabilityRouteRef
  }
});
const VulnerabilitiesPage = vulnerabilitiesPlugin.provide(
  createRoutableExtension({
    name: "VulnerabilitiesPage",
    component: () => import('./components/vulnerabilitiesHomePage/index.esm.js').then((m) => m.VulnerabilitiesHomePage),
    mountPoint: rootRouteRef
  })
);
const VulnerabilitiesOverviewCard = vulnerabilitiesPlugin.provide(
  createRoutableExtension({
    name: "VulnerabilitiesOverviewCard",
    component: () => import('./components/vulnerabilitiesOverviewCard/index.esm.js').then((m) => m.VulnerabilitiesOverviewCard),
    mountPoint: rootRouteRef
  })
);
vulnerabilitiesPlugin.provide(
  createRoutableExtension({
    name: "VulnerabilityPage",
    component: () => import('./components/VulnerabilitiesReportComponent/VulnerabilityReportPage.esm.js').then((m) => m.VulnerabilityReportPage),
    mountPoint: vulnerabilityRouteRef
  })
);

export { VulnerabilitiesOverviewCard, VulnerabilitiesPage, vulnerabilitiesPlugin };
//# sourceMappingURL=plugin.esm.js.map
